<template>
  <form @submit.prevent="handleSubmit">

    <div class="card-panel">
      <div class="input-field">
        <input type="text" v-model="name" class="validate" required />
        <label class="active teal-text" for="name">Spouse Name <i class="tiny material-icons pointable orange-text"
            title="required">star</i></label>
      </div>
    </div>

    <div class="card-panel">
      <div class="row">
        <div class="col s10">
          <div class="file-field input-field">
            <div class="btn grey">
              <span>Change</span>
              <input type="file" @change="handleFile" />
            </div>
            <div class="file-path-wrapper">
              <input class="file-path" v-model="inputFile" type="text" />
              <p v-if="fileError">{{ fileError }}</p>
            </div>
          </div>
        </div>
        <div class="col s2">
          <LoadingSmallDiv v-if="isLoading" />
          <span v-else>
            <img alt="" :src="img" width="64" class="circle responsive-img" v-if="img" />
            <img alt="" src="https://ui-avatars.com/api/?name=S&size=128" width="64" class="circle responsive-img" v-else />
          </span>
        </div>
      </div>
    </div>

    <div class="card-panel">
      <div class="input-field">
        <label class="active teal-text" for="sex">Sex</label>
        <select id="sex" v-model="sex" disabled>
          <option value="m">Male</option>
          <option value="f">Female</option>
        </select>
      </div>
    </div>


    <div class="card-panel">
      <div class="row">
        <div class="input-field col s2">
          <input id="day" type="number" v-model="birthDay" min="1" max="31" class="validate" required />
          <label class="active teal-text" for="day">Birth Day <i class="tiny material-icons pointable orange-text"
              title="required">star</i></label>
        </div>
        <div class="input-field col s6">
          <label class="active teal-text" for="month">Birth Month <i class="tiny material-icons pointable orange-text"
              title="required">star</i></label>
          <select id="month" v-model="birthMonth" class="validate" required>
            <option value="" selected>Select Month</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        <div class="input-field col s4">
          <input id="year" type="number" v-model="birthYear" min="1900" class="validate" required />
          <label class="active teal-text" for="year">Birth Year <i class="tiny material-icons pointable orange-text"
              title="required">star</i></label>
        </div>
      </div>
      <div class="age-policy-note" v-if="ageError">
        <i class="material-icons">policy</i>
        <span>{{ ageError }}</span>
      </div>
    </div>

    <div class="card-panel">
      <div class="input-field">
        <input type="text" v-model="enrolleeNumber" />
        <label class="active teal-text" for="email">Enrollee ID</label>
      </div>
    </div>

    <!-- <div class="card-panel">
        <div class="input-field">
          <input type="text" v-model="phone" class="validate" />
          <label class="active teal-text" for="phone">Phone</label>
        </div>
      </div> -->

    <!-- <div class="card-panel">
        <div class="input-field">
          <input type="email" v-model="email" class="validate" />
          <label class="active teal-text" for="email">Email</label>
        </div>
      </div> -->

    <!-- <div class="card-panel">
        <div class="input-field">
          <input type="text" v-model="address" class="validate" />
          <label class="active teal-text" for="address">Address</label>
        </div>
      </div> -->

    <div class="card-panel">
      <p>
        <br />
        <a
          href="#"
          class="text-back-action"
          :class="{
            disabled: isSubmitting,
          }"
          @click.prevent="handleBack"
        >
          <i class="material-icons">arrow_back</i>Back
        </a>
        <button class="waves-effect waves-light btn-large" :class="{
          disabled: !name || !sex || !birthDay || !birthMonth || !birthYear || isSubmitting || ageError,
        }">
          <i class="material-icons right">check_circle</i>{{ isSubmitting ? "Adding" : "Add Spouse" }}
        </button>
      </p>
    </div>
  </form>
</template>

<script>
import { computed, onMounted, onUpdated, ref, watchEffect } from "vue";
import postItem from "@/composables/postItem";
import useStorage from "@/composables/useStorage";
import LoadingSmallDiv from "@/components/LoadingSmallDiv.vue";
import nativeUi from "@/ui/native-ui";

export default {
  name: "EnrolleeEditDependantOnboardComponent",
  components: { LoadingSmallDiv },
  props: ["enrollee", "policy", "serverDate"],
  emits: ["reset"],
  setup(props, context) {
    const file = ref(null);
    const inputFile = ref(null);
    const fileError = ref(null);
    const name = ref(null);
    const sex = ref(null);
    const birthDay = ref(null);
    const birthMonth = ref(null);
    const birthYear = ref(null);
    const enrolleeNumber = ref(null);
    const phone = ref(null);
    const email = ref(null);
    const address = ref(null);
    const isSubmitting = ref(false);
    const isLoading = ref(false);
    const error = ref(null);
    const img = ref(null);
    const types = ["image/jpg", "image/jpeg", "image/png", "image/gif"];
    const parseLocalDate = (value) => {
      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split("-").map(Number);
        return new Date(year, month - 1, day);
      }

      return new Date(value);
    };
    const referenceDate = computed(() => {
      const date = props.serverDate ? parseLocalDate(props.serverDate) : new Date();
      return isNaN(date) ? new Date() : date;
    });
    const principalAgeLimit = computed(() => Number(props.policy?.principal_age) || 0);
    const birthDate = computed(() => formatBirthDate());
    const memberAge = computed(() => calculateAge(birthDate.value));
    const ageError = computed(() => {
      if (!principalAgeLimit.value || memberAge.value === null) return null;
      if (memberAge.value > principalAgeLimit.value) {
        return `Spouse age exceeds the current policy limit of ${principalAgeLimit.value} years.`;
      }
      return null;
    });

    // storage
    const { uploadFile, uploadProgress, uploadError, data, completed } =
      useStorage();


    // select
    onMounted(() => {
      // set spouse sex
      if (props.enrollee.sex == "m") {
        sex.value = "f"
      } else {
        sex.value = "m"
      }

      // set other variables
      email.value = null;
      phone.value = props.enrollee.phone;
      address.value = props.enrollee.address;
    });


    // select
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      nativeUi.FormSelect.init(elemsSelect, {});
    });

    // select
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      nativeUi.FormSelect.init(elemsSelect, {});
    });

    // clear
    const clearForm = () => {
      file.value = null; //clear file value
      inputFile.value = null; // Clear the file input value
      isSubmitting.value = false;
      isLoading.value = false;
      uploadProgress.value = "0%";
    };

    // handle file
    const handleFile = (e) => {
      const selected = e.target.files[0];
      if (selected && types.includes(selected.type)) {
        file.value = selected;
        inputFile.value = file.value.name;
        fileError.value = null;
      } else {
        file.value = null;
        inputFile.value = null;
        fileError.value = "Please select an Image (.JPG, .PNG, .GIF)";
      }
    };

    // handle back
    const handleBack = () => {
      context.emit("reset", null);
    };

    const formatBirthDate = () => {
      const pad = n => String(n).padStart(2, '0');
      const y = birthYear.value, m = birthMonth.value, d = birthDay.value;

      if (y == null || m == null || d == null || y === "" || m === "" || d === "") {
        return null;
      }

      const dateStr = `${y}-${pad(m)}-${pad(d)}`;
      const date = parseLocalDate(dateStr);

      const isValid = !isNaN(date) &&
        date.getFullYear() === Number(y) &&
        date.getMonth() + 1 === Number(m) &&
        date.getDate() === Number(d);

      return isValid ? dateStr : null;
    };

    const calculateAge = (dateStr) => {
      if (!dateStr) return null;

      const date = parseLocalDate(dateStr);
      const today = referenceDate.value;
      let age = today.getFullYear() - date.getFullYear();
      const monthDiff = today.getMonth() - date.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
        age -= 1;
      }

      return age;
    };

    //hand
    watchEffect(() => {
      if (file.value) {
        // start ploading
        isLoading.value = true;
        uploadError.value = null;

        // upload image
        uploadFile(file.value);
      }
    });

    //handle submit
    const handleSubmit = async () => {
      // Native form validation handles custom errors \\
      if (ageError.value) {
        error.value = ageError.value;
        return;
      }

      // start
      isSubmitting.value = true;
      error.value = false;
      uploadProgress.value = false;

      let newDOB = birthDate.value;

      // variable
      const newVal = {
        client_id: props.enrollee.client_id,
        principal_id: props.enrollee.id,
        provider_id: props.enrollee.provider_id,
        plan_id: props.enrollee.plan_id,
        name: name.value,
        sex: sex.value,
        dob: newDOB,
        enrollee_number: enrolleeNumber.value,
        profile_img: img.value,
        email: email.value || null,
        phone: phone.value,
        address: address.value,
      };

      // post item
      const { res, err } = await postItem(
        "spouse",
        newVal
      );

      if (res.value) {
        // start
        let spouse = res.value.data;
        let principal = props.enrollee;

        // merge with principal
        principal.spouse = spouse;

        // add spouse email
        principal.spouse.user = {};
        principal.spouse.user.email = email.value || null;


        // go back
        context.emit("reset", principal);
      } else {
        error.value = err.value;
      }

      // end here
      // clear
      clearForm();
    };

    // watch tariff upload
    watchEffect(() => {
      if (completed.value) {
        // set image
        img.value = data.value;
        // clear
        clearForm();
        // data.succ.Success, data.succ.inserted_rows, data.succ.Error
        // console.log(data); // might not be necessary
      }
      if (uploadError.value) {
        // clear
        clearForm();
      }
    });

    return {
      handleFile,
      handleBack,
      handleSubmit,
      isSubmitting,
      isLoading,
      uploadProgress,
      fileError,
      uploadError,
      img,
      file,
      inputFile,
      name,
      sex,
      birthDay,
      birthMonth,
      birthYear,
      enrolleeNumber,
      ageError,
      email,
      phone,
      address,
    };
  },
};
</script>

<style scoped>
.text-back-action {
  align-items: center;
  color: #455a64;
  display: inline-flex;
  gap: 5px;
  font-weight: 600;
  margin-right: 14px;
  padding: 12px 0;
}

.text-back-action i {
  font-size: 18px;
}

.text-back-action.disabled {
  opacity: 0.55;
  pointer-events: none;
}

.age-policy-note {
  align-items: center;
  background: #fff3e0;
  border-left: 4px solid #ef6c00;
  border-radius: 4px;
  color: #4e342e;
  display: flex;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 12px;
}

.age-policy-note i {
  color: #ef6c00;
  font-size: 20px;
}
</style>
